import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { CrprgpTable } from "./CrprgpTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
  postSynch,
} from "./crprgpSlice";
import { useHistory } from "react-router";

import {
  showSuccessDialog,
  showErrorDialog,
  showDeleteDialog,
  showConfirmDialog,
} from "../../../utility";

export const CRPRGPPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [clientCode, setClientCode] = useState("");
  const [nonReturnable, setNonReturnable] = useState("");
  const [crpBefore, setCrpBefore] = useState("");
  const [crpAfter, setCrpAfter] = useState("");

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  const handleSearch = () => {
    const params = {
      clientCode: clientCode,
      nonReturnable: nonReturnable,
      crpBefore: crpBefore,
      crpAfter: crpAfter,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      clientCode: clientCode,
      nonReturnable: nonReturnable,
      crpBefore: crpBefore,
      crpAfter: crpAfter,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleSynch = async (row) => {
    let params = {};

    const action = await showConfirmDialog(
      `do you want to sync crprgp ? It took about 2 hours to finish`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(postSynch(params));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          if (action.isConfirmed) await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="CRP RGP">
        <CardHeaderToolbar>
          <Button variant="primary" onClick={handleSynch}>
            Sync
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Client Code"
                    onChange={(e) => {
                      setClientCode(e.target.value);
                    }}
                    value={clientCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Non Returnable</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Non Returnable"
                    onChange={(e) => {
                      setNonReturnable(e.target.value);
                    }}
                    value={nonReturnable}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Crp Before</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Crp Before"
                    onChange={(e) => {
                      setCrpBefore(e.target.value);
                    }}
                    value={crpBefore}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Crp After</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Crp After"
                    onChange={(e) => {
                      setCrpAfter(e.target.value);
                    }}
                    value={crpAfter}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <CrprgpTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
